/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { paginationLinks } from '../models/paginationLinks'
import type { paginationMeta } from '../models/paginationMeta'
import type { RetryableJobResource } from '../models/RetryableJobResource'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class RetryableJobsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public listRetryableJobs({
        page,
        oid,
        error,
        className,
        retried
    }: {
        /**
         * The page to retrieve starting with page 1.
         */
        page?: number
        /**
         * Filter by OID
         */
        oid?: number
        /**
         * Filter by error
         */
        error?: string
        /**
         * Filter by class name
         */
        className?: string
        /**
         * Filter by retried
         */
        retried?: boolean
    }): CancelablePromise<{
        data: Array<RetryableJobResource>
        meta: paginationMeta
        links: paginationLinks
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/retryable-jobs',
            query: {
                page: page,
                oid: oid,
                error: error,
                class_name: className,
                retried: retried
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public showRetryableJob({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<{
        data: RetryableJobResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/retryable-jobs/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public retryRetryableJob({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/retryable-jobs/{id}/retry',
            path: {
                id: id
            },
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
